/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { ChatCancelToolCallPathParams, ChatCancelToolCallResponse } from '../types/ChatCancelToolCall'

/**
 * POST /chat/:chat/tool-calls/:toolCallId/cancel
 * @see backend/nexus/modules/AdGeneration/Http/Controllers/ChatController.php ChatController::cancelToolCall
 */
export async function chatCancelToolCall(
	chat: ChatCancelToolCallPathParams['chat'],
	toolCallId: ChatCancelToolCallPathParams['toolCallId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<ChatCancelToolCallResponse>> {
	return axiosInstance.post(`/chat/${chat}/tool-calls/${toolCallId}/cancel`, undefined, config)
}
